export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-embed/_content-section-embed.twig";